import React, { Children } from "react";
import HeadVideo from "../school_images/Basic_English_Class_Facebook_Cover.mp4";
import HeadImage from "../school_images/hostel.jpeg";
import Navbaartesting from "../components/Navbaartesting";
import styled from "styled-components";
import "../styleCSS/indexpage.css";
import HeroTenetsSection from "./HeroTenetsSection";
import "../styleCSS/Navbar.css";
import EnqButton from "../components/EnqButton";
import Carousal from "../components/Carousal";
import Slider from "../components/Slider";
import WhyChooseUs from "../components/WhyChooseUs";
import AboutUsComponent from "../components/AboutUsComponent";
import ServicesComponent from "../components/ServicesComponent";
import MarketingComponent from "../components/MarketingComponent";
import Collapsible from "../components/Collapsible";
import FAQComponet from "../components/FAQComponet";
import AppointmentForm from "../components/AppointmentForm";
import Footer from "../components/Footer";
import DigitalMarketingServices from "../components/DigitalMarketingServices";
import TestimonialSection from "../components/TestimonialSection";
import ClientsSlider from "../components/ClientsSlider";
import LogoSlider from "../components/LogoSlider";



const Home = ({children}) => {
  return (
    <HomeContainer>
         <Navbaartesting /> {children || 
     <div>
     
      <Slider />
      <WhyChooseUs/>
      <AboutUsComponent/>
      <ServicesComponent/>
      <MarketingComponent/>
      <LogoSlider/>
     
      <Collapsible/>
      <FAQComponet/>
      <DigitalMarketingServices/>
      <AppointmentForm/>
          
      <TestimonialSection/>
      
     </div> }
     <Footer/>
    </HomeContainer>
  );
};

export default Home;

const HomeContainer = styled.div`
  width: 100vw;
  height: auto;
`;
